export const HOME_ROUTE_NAMES = {
  MAIN: "home",
} as const;

export type HomeRouteNames =
  (typeof HOME_ROUTE_NAMES)[keyof typeof HOME_ROUTE_NAMES];
